import { gsap, ScrollTrigger } from "gsap/all";

export default function initgsapSwapBackground() {
	function gsapSwapBackground(section) {
		const forcedBg = section.getAttribute("swap-bg"); // Get the forced bg once, as it doesn't change

		ScrollTrigger.create({
			trigger: section,
			start: "top center",
			end: "bottom center",

			// markers: {
			// 	startColor: "green",
			// 	endColor: "red",
			// 	fontSize: "14px",
			// 	indent: 10,
			// },
			// id: `Trigger: ${forcedBg}`,

			// onToggle: (self) => {
			//     // Check if the section is currently in the viewport (isActive)
			//     // If active, set the "data-theme" attribute to the forced theme
			//     // If not active, revert to the "default" theme
			//     document.documentElement.setAttribute(
			//         "data-theme",
			//         self.isActive ? forcedBg : ''
			//     );
			// }

			onEnter: () => {
				// When entering the section, set the "data-theme" attribute to the forced theme
				document.body.classList.add(`swap-bg--${forcedBg}`);
			},
			onEnterBack: () => {
				// When scrolling back and re-entering the section, set the "data-theme" attribute to the forced theme
				document.body.classList.add(`swap-bg--${forcedBg}`);
			},
			onLeave: () => {
				// When leaving the section, revert to the "default" theme
				document.body.classList.remove(`swap-bg--${forcedBg}`);
			},
			onLeaveBack: () => {
				// When scrolling back and leaving the section, revert to the "default" theme
				document.body.classList.remove(`swap-bg--${forcedBg}`);
			},
		});
	}
	gsap.utils
		.toArray("[swap-bg]")
		.forEach((section) => gsapSwapBackground(section));
}
